/**
 * Systemowe uprawnienia (CASL Actions)
 * Super admin może przydzielać te uprawnienia innym użytkownikom
 * Na razie głównie na backendzie, front je odczytuje i ukrywa/pokazuje UI
 */
export enum SystemPermission {
  // User Management
  MANAGE_USERS = 'manage_users',
  VIEW_USERS = 'view_users',
  CREATE_USERS = 'create_users',
  EDIT_USERS = 'edit_users',
  DELETE_USERS = 'delete_users',

  // Reports
  VIEW_REPORTS = 'view_reports',
  EXPORT_REPORTS = 'export_reports',

  // Settings
  MANAGE_SETTINGS = 'manage_settings',
  VIEW_AUDIT_LOG = 'view_audit_log',

  // Content Management
  PUBLISH_CONTENT = 'publish_content',
  MANAGE_CONTENT = 'manage_content',

  // Permissions
  GRANT_PERMISSIONS = 'grant_permissions',
  REVOKE_PERMISSIONS = 'revoke_permissions',

  // Request board („Szukam noclegu”) — kody 1:1 z backendem (SystemPermission)
  /** Składanie/wycofywanie propozycji (rola org OWNER/MANAGER; nadawane przez backend z roli w organizacji). */
  REQUEST_BOARD_PROPOSE = 'request_board.propose',
  /** Moderacja tablicy (ADMIN/SUPER_ADMIN) — panel admina. */
  REQUEST_BOARD_MODERATE = 'request_board.moderate',
}

/**
 * Mapowanie permissji na label do wyświetlania
 */
export const SYSTEM_PERMISSION_LABELS: Record<SystemPermission, string> = {
  [SystemPermission.MANAGE_USERS]: 'Zarządzanie użytkownikami',
  [SystemPermission.VIEW_USERS]: 'Podgląd użytkowników',
  [SystemPermission.CREATE_USERS]: 'Tworzenie użytkowników',
  [SystemPermission.EDIT_USERS]: 'Edycja użytkowników',
  [SystemPermission.DELETE_USERS]: 'Usuwanie użytkowników',
  [SystemPermission.VIEW_REPORTS]: 'Podgląd raportów',
  [SystemPermission.EXPORT_REPORTS]: 'Eksport raportów',
  [SystemPermission.MANAGE_SETTINGS]: 'Zarządzanie ustawieniami',
  [SystemPermission.VIEW_AUDIT_LOG]: 'Podgląd dziennika audytu',
  [SystemPermission.PUBLISH_CONTENT]: 'Publikowanie treści',
  [SystemPermission.MANAGE_CONTENT]: 'Zarządzanie treścią',
  [SystemPermission.GRANT_PERMISSIONS]: 'Przyznawanie uprawnień',
  [SystemPermission.REVOKE_PERMISSIONS]: 'Odbieranie uprawnień',
  [SystemPermission.REQUEST_BOARD_PROPOSE]: 'Składanie propozycji („Szukam noclegu”)',
  [SystemPermission.REQUEST_BOARD_MODERATE]: 'Moderacja tablicy „Szukam noclegu”',
};
